/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newpatient_Addfirstanimal3Inputs */

const en_newpatient_addfirstanimal3 = /** @type {(inputs: Newpatient_Addfirstanimal3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a profile for your pet`)
};

const fr_newpatient_addfirstanimal3 = /** @type {(inputs: Newpatient_Addfirstanimal3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer un profil pour votre animal`)
};

/**
* | output |
* | --- |
* | "Create a profile for your pet" |
*
* @param {Newpatient_Addfirstanimal3Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const newpatient_addfirstanimal3 = /** @type {((inputs?: Newpatient_Addfirstanimal3Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newpatient_Addfirstanimal3Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_newpatient_addfirstanimal3(inputs)
	return fr_newpatient_addfirstanimal3(inputs)
});
export { newpatient_addfirstanimal3 as "newPatient_addFirstAnimal" }